import { render, staticRenderFns } from "./QuestionCardV2.vue?vue&type=template&id=0707866e&scoped=true"
import script from "./QuestionCardV2.vue?vue&type=script&lang=js"
export * from "./QuestionCardV2.vue?vue&type=script&lang=js"
import style0 from "./QuestionCardV2.vue?vue&type=style&index=0&id=0707866e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707866e",
  null
  
)

export default component.exports